<template>
  <div>
    <el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
            <el-select v-model="selectMore" slot="prepend" placeholder="请选择">
              <el-option label="内部ID/任务单号" value="1"></el-option>
              <el-option label="设备ID" value="2"></el-option>
              <el-option label="Mac地址" value="3"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">快速筛选:
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-select v-model="Color" placeholder="所有颜色" size="small" style="width: 100px;"
                     @change="Quickfind">
            <el-option label="所有颜色" value=""></el-option>
            <el-option label="黑金" value="1"></el-option>
            <el-option label="白红" value="2"></el-option>
            <el-option label="白灰" value="3"></el-option>
            <el-option label="样机" value="5"></el-option>
            <el-option label="钢铁侠" value="6"></el-option>
            <el-option label="酒红" value="7"></el-option>
            <el-option label="纯黑" value="8"></el-option>
            <el-option label="鸟蓝" value="9"></el-option>
            <el-option label="粉白" value="10"></el-option>
            <el-option label="白色" value="257"></el-option>
            <el-option label="红色" value="258"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="Ver" placeholder="所有版本" size="small" style="width: 100px;" @change="Quickfind">
            <el-option label="所有版本" value=""></el-option>
            <el-option label="标准版" value="1"></el-option>
            <el-option label="运动舒适版" value="2"></el-option>
            <el-option label="运动基本版" value="3"></el-option>
            <el-option label="运动豪华版" value="4"></el-option>
            <el-option label="运动工伤版" value="5"></el-option>
            <el-option label="运动旗舰版" value="6"></el-option>
            <el-option label="电动推杆" value="7"></el-option>
            <el-option label="运动lite版" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="Spring" placeholder="所有气弹簧" size="small" style="width: 200px;"
                     @change="Quickfind">
            <el-option label="所有气弹簧" value=""></el-option>
            <el-option label="800" value="1"></el-option>
            <el-option label="600" value="2"></el-option>
            <el-option label="未知" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight"
              @selection-change="selsChange">
      <el-table-column type="selection" width="50" :selectable='checkboxInit'></el-table-column>
      <!--<el-table-column label="任务单号" prop="sid" :formatter="dataForm"></el-table-column>-->
      <!--<el-table-column label="Sid" prop="sid"></el-table-column>-->
      <el-table-column label="Did" prop="did"></el-table-column>
      <el-table-column label="Mac" prop="mac"></el-table-column>
      <el-table-column label="颜色" prop="color"></el-table-column>
      <el-table-column label="版本" prop="edition"></el-table-column>
      <el-table-column label="气弹簧" prop="spring"></el-table-column>
      <!--    		<el-table-column label="入库时间" prop="storage_date" :formatter="dateFormat"></el-table-column>-->
      <!--    		<el-table-column label="确认入库时间" prop="receipt_date" :formatter="dateFormat"></el-table-column>-->
      <el-table-column label="操作" width="100" v-if="Limits.warehoused_receipt">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.receipt_date == 0" type="primary"
                     @click="Makesure(scope.$index,scope.row,scope.column)">确认入库
          </el-button>
          <el-button size="mini" type="success" v-if="scope.row.receipt_date != 0" disabled>已确认</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar downtool">
      <el-button v-if="Limits.warehoused_deliver" type="primary" :disabled="this.sels.length === 0"
                 @click="OpenClear" size="small">出货
      </el-button>
      <el-button v-if="Limits.delivered_index" type="primary" size="small" @click="ShowIn">显示已出货设备</el-button>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize"
                     :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
    </el-col>

    <el-dialog title="出货" :visible.sync="ChuVisible" top="5%" width='80%'>
      <el-form :inline="false" :model="Cform" :rules="rules" size="mini">
        <el-form-item label="智能识别" label-width="100px">
          <el-input v-model="autoinputmsg" placeholder="请输入收货信息，形如：“张三 13262508070  北京市东城区长安街”">
            <el-button slot="append" icon="el-icon-edit-outline" @click="AutoInput">自动填入</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="出货流水" label-width="100px" prop="liushui">
          <el-input v-model="Cform.liushui" placeholder="请输入正确的11位流水号" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="发货日期" label-width="100px" prop="cct">
          <el-date-picker v-model="Cform.cct" type="date" placeholder="选择日期"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <!--</el-form>-->
        <!--<el-form :inline="true" :rules="rules">-->
        <el-form-item label="发货地区" label-width="100px" prop="ssq">
          <el-cascader :options="Addoptions" v-model="Cform.ssq" style="width: 100%;"
                       expand-trigger="hover"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" label-width="100px" prop="xxdz">
          <el-input style="width:300px" v-model="Cform.xxdz" placeholder="请填写详细地址"></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="false" :model="Cform" :rules="rules2" size="mini">
        <el-form-item label="收货人" label-width="100px" prop="getperson">
          <el-input v-model="Cform.getperson" placeholder="请填写收货人姓名(不超过5个字)" :maxlength="5"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话" label-width="100px" prop="getphone">
          <el-input v-model="Cform.getphone" placeholder="请填写收货人联系方式" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="经销商" label-width="100px" prop="jxs">
          <el-select v-model="Cform.jxs" placeholder="请选择经销商（不填则默认“上海邦邦机器人有限公司”）" style="width: 100%;">
            <el-option v-for="item in Dealerlist" :label='item.name' :key="item.index"
                       :value='item.id'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="Cform" :rules="rules3" size="mini">
        <el-form-item label="出货人" label-width="100px" prop="person">
          <el-input v-model="Cform.person" placeholder="请填写出货人姓名(不超过5个字)" :maxlength="5"></el-input>
        </el-form-item>
        <el-form-item label="设备类别" label-width="100px" prop="kind">
          <el-select v-model="Cform.kind" placeholder="请选择设备类别" style="width: 100%;">
            <el-option label="终端客户（个人）" value="1"></el-option>
            <el-option label="终端客户（单位）" value="5"></el-option>
            <el-option label="经销商客户（购销）" value="2"></el-option>
            <el-option label="经销商客户（押金）" value="6"></el-option>
            <el-option label="公司内部（市场）" value="3"></el-option>
            <el-option label="公司内部（研发）" value="7"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <el-form size="mini">

        <el-table :data="OutList" border style="width: 100%">
          <el-table-column label="Did" width="250" prop="did"></el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="scope.row.remark"
                        :maxlength="50"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!--<el-form-item label="其他备注" label-width="100px" prop="more">
              <el-input v-model="Cform.more"  placeholder="经销商为邦邦机器人时请填写(不超过50个字)" :maxlength="50"></el-input>
        </el-form-item>-->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ChuVisible = false">取 消</el-button>
        <el-button type="primary" @click="Chuhuo" :loading="UpOutloading">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="已出货设备" :visible.sync="OutVisible" :fullscreen="true">
      <el-col :span="24" class="toolbar uptool">
        <el-input placeholder="输入设备DID" v-model="shippedDid" class="input-with-select" size="small"
                  style="width: 15rem;">
          <el-button slot="append" icon="el-icon-search" @click="queryShippedDid">搜索</el-button>
        </el-input>
      </el-col>

      <el-table :data="List2" border v-loading="listloading2" @selection-change="selsChange">
        <!--<el-table-column label="SID" prop="sid"></el-table-column>-->
        <el-table-column label="DID" prop="did"></el-table-column>
        <el-table-column label="MAC" prop="mac"></el-table-column>
        <el-table-column label="颜色" prop="color" width="60"></el-table-column>
        <el-table-column label="气弹簧" prop="spring" width="70"></el-table-column>
        <el-table-column label="版本" prop="edition" width="70"></el-table-column>
        <el-table-column label="流水号" prop="deliveryOrder.serial_number"></el-table-column>
        <el-table-column label="发货日期">
          <template slot-scope="scope">
            {{chuTimeFormatter(scope.row.deliveryOrder.delivery_date)}}
          </template>
        </el-table-column>
        <el-table-column label="经销商" prop="dealer"></el-table-column>
        <el-table-column label="出货地址">
          <template slot-scope="scope">
						<span v-if="scope.row.deliveryOrder.shipping_prov == '无'">
							无
						</span>
            <span v-if="scope.row.deliveryOrder.shipping_prov != '无'">
							<span>{{scope.row.deliveryOrder.shipping_prov}}</span>
							<span v-if="scope.row.deliveryOrder.shipping_city != scope.row.deliveryOrder.shipping_prov">{{scope.row.deliveryOrder.shipping_city}}</span>
							<span>{{scope.row.deliveryOrder.shipping_dist}}</span>
							<span>{{scope.row.deliveryOrder.shipping_addr}}</span>
						</span>
          </template>
        </el-table-column>
        <el-table-column label="收货人" prop="deliveryOrder.receiver"></el-table-column>
        <el-table-column label="出货人" prop="deliveryOrder.shipper" width="80"></el-table-column>
        <el-table-column label="备注" prop="deliveryOrder.remark"></el-table-column>
        <el-table-column label="操作" width="100" v-if="Limits.warehoused_receipt">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="confirmRefundDevice(scope.$index,scope.row,scope.column)">
              退货
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2"
                       :current-page="Curpage2" :total="total2" style="float:right;">
        </el-pagination>
      </el-col>

      <el-dialog title="补充退货信息" :visible.sync="showRefundInfoDialog" :before-close="handleRefundInfoDialogClose"
                 append-to-body>
        <el-form :model="refundInfo" :rules="refundInfoRules" ref="refundForm">
          <el-form-item label="退货接收时间" label-width="100px" prop="return_date">
            <el-date-picker
              v-model="refundInfo.return_date"
              type="date"
              size="mini"
              :editable="false"
              :clearable="true"
              format="yyyy/M/d"
              value-format="timestamp"
              placeholder="请选择收到退货设备的日期"
              :picker-options="pickerOptions"
              style="width:220px;margin-left: 10px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="退货原因" label-width="100px" prop="reason">
            <el-input v-model="refundInfo.reason" placeholder="请输入退货原因（不超过50字）"/>
          </el-form-item>
          <el-form-item label="检测结论" label-width="100px" prop="detection_result">
            <el-input v-model="refundInfo.detection_result" placeholder="请输入设备检验结果（不超过100字）"/>
          </el-form-item>
          <el-form-item label="经办人" label-width="100px" prop="agent">
            <el-input v-model="refundInfo.agent" placeholder="请输入退货经办人姓名（不超过10字）"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRefundInfoDialog = false">取 消</el-button>
          <el-button type="danger" @click="doRefundDevice">退 货</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
  import {CountryThree} from '../common/js/countrythree'
  import {GetWarehouslist, GetDealerlist, GetDeliverlist, RefundDevice} from '../api/api';
  import moment from 'moment'

  export default {
    data() {
      return {
        Time: "",
        maxHeight: 600,
        Limits: "",
        token: "",
        inputMore: "",
        selectMore: "",
        Color: "",
        Ver: "",
        Spring: "",
        List: [],
        listloading: false,
        Pagesize: 20,
        Curpage: 1,
        total: 1,
        Form: {
          id: ""
        },
        sels: [],
        Dealerlist: [],
        ChuVisible: false,
        UpOutloading: false,
        rules: {
          liushui: [
            {required: true, message: '请输入流水号', trigger: 'blur'},
            {min: 11, max: 11, message: '请输入正确的11位流水号', trigger: 'blur'}
          ],
          cct: [
            {required: true, message: '请选择日期', trigger: 'blur'},
          ],
          ssq: [
            {required: true, message: '请选择地区', trigger: 'change'}
          ],
          xxdz: [
            {required: true, message: '请填写详细地址', trigger: 'blur'}
          ],
        },
        rules2: {
          getperson: [
            {required: true, message: '请填写收货人', trigger: 'blur'}
          ],
          getphone: [
            {required: true, message: '请填写收货人联系方式', trigger: 'blur'}
          ],
          jxs: [
            {required: true, message: '请选择经销商', trigger: 'change'}
          ]
        },
        rules3: {
          person: [
            {required: true, message: '请填写出货人', trigger: 'blur'}
          ],
          kind: [
            {required: true, message: '请选择设备类别', trigger: 'change'}
          ],
        },
        OutList: [],
        autoinputmsg: '',
        Cform: {
          liushui: "",
          cct: "",
          jxs: 1,// 不填默认“上海邦邦机器人有限公司”
//					more:"",
          person: "",
          kind: "",
          getperson: "",
          getphone: "",
          ssq: [],
          xxdz: "",
        },
        add: {
          shipping_prov: "",
          shipping_city: "",
          shipping_dist: "",
          shipping_addr: ""
        },
        List2: [],
        OutVisible: false,
        listloading2: false,
        Pagesize2: 20,
        Curpage2: 1,
        total2: 1,
        Screenall: {},
        Addoptions: [],
        shippedDid: '', //查找已发货设备
        showRefundInfoDialog: false,
        refundRow: {},
        refundInfo: { // 退货信息
          return_date: Date.parse(new Date()), // 退货时间
          reason: '',// 退货原因
          detection_result: '',// 设备检测结论
          agent: '',// 经办人
        },
        refundInfoRules: {
          return_date: [
            {required: true, message: '请选择收到退货设备的日期', trigger: 'blur'}
          ],
          reason: [
            {required: true, message: '请输入退货原因（不超过50字）', trigger: 'blur'},
            {min: 0, max: 50, message: '不超过50字', trigger: 'blur'}
          ],
          detection_result: [
            {required: true, message: '请输入设备检验结果（不超过100字）', trigger: 'blur'},
            {min: 0, max: 100, message: '不超过100字', trigger: 'blur'}
          ],
          agent: [
            {required: true, message: '请输入退货经办人姓名（不超过10字）', trigger: 'blur'},
            {min: 1, max: 10, message: '不超过10字', trigger: 'blur'}
          ]
        },
        pickerOptions: {
          disabledDate(time) {
            // 最晚到昨天
            let now = new Date()
            let todayZero = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
            let tommorowZeroTime = todayZero.getTime() + 3600 * 1000 * 24 * 1
            return time.getTime() >= tommorowZeroTime;
          },
        }
      }
    },
    methods: {
      handleRefundInfoDialogClose() {
        this.showRefundInfoDialog = false
        this.refundInfo.reason = ''
        this.refundInfo.detection_result = ''
      },
      doRefundDevice() {
        var that = this
        this.$refs.refundForm.validate(valid => {
          if (valid) {
            that.$confirm('提交信息并退货？').then(res => {
              let params = JSON.parse(JSON.stringify(this.refundInfo))
              params.return_date /= 1000
              console.log('doRefundDevice-1', res, params, that.refundRow, that.refundRow.id)
              RefundDevice(this.token, that.refundRow.id, params).then(res => {
                // 退货成功
                that.showRefundInfoDialog = false
                that.$message({
                  type: 'success',
                  message: '退货成功'
                });
                // 重新刷新“已发货设备列表”
                that.GetList2(GetDeliverlist, {page: this.Curpage2, token: this.token, sort: "-id"})
              }).catch(err => {
                // 退货失败
                that.$message.error('退货失败')
              })
            }).catch(err => {
              console.log('doRefundDevice-2', err)
            })
          } else {

          }
        })
      },
      confirmRefundDevice(index, row, col) {
        console.log('confirmRefundDevice', index, row, col)
        this.refundRow = row

        this.$confirm('确认退货？').then(res => {
          console.log('confirmRefundDevice-1', res)
          // 显示退货信息表
          this.showRefundInfoDialog = true
        }).catch(err => {
          console.log('confirmRefundDevice-2', err)
        })
      },
      queryShippedDid() {
        if (this.shippedDid) {
          let params = {
            token: this.token,
            q: "[{\"AND\":{\"did\":\"" + this.shippedDid + "\"}}]"
          }
          console.log('queryShippedDid', params)
          this.GetList2(GetDeliverlist, params)
        }
      },
      Find() {
        if (this.selectMore && this.inputMore) {
          this.Quickfind()
        }
      },
      AutoInput() {

        var tmp = this.autoinputmsg.trim().split(/\s+/);

        console.log('lbfautoinputmsg', tmp);

        var username = tmp[0];
        var phone = tmp[1];
        var address = tmp[2];
        var ssqtmp = [];
        for (var province_index in this.Addoptions) {// 遍历省、直辖市
          var province = this.Addoptions[province_index];
          if (address.indexOf(province.value) !== -1) {
            ssqtmp[0] = province.value;
            for (var city_index in province.children) {// 遍历市
              var city = province.children[city_index];
              if (address.indexOf(city.value) !== -1) {
                ssqtmp[1] = city.value;
                for (var district_index in city.children) {
                  var district = city.children[district_index];
                  var index;
                  if ((index = address.indexOf(district.value.substr(0, district.value.length - 1))) !== -1) {
                    ssqtmp[2] = district.value;
                    this.Cform.xxdz = address.substr(index + district.value.length, address.length - index);
                  }
                }
              }
            }
          }
        }

        this.Cform.getperson = username;
        this.Cform.getphone = phone;
        this.Cform.ssq = ssqtmp;

        console.log('lbfautoinputmsg-ssq', this.Cform.ssq);
      },
      Quickfind() {
        var all
        if (this.selectMore && this.inputMore) {
//					if(this.selectMore == 1){
//						all = {
//							sid:'~'+this.inputMore,
//							color_code:this.Color,
//							edition_code:this.Ver,
//							spring_code:this.Spring,
//						}
//					}else 
          if (this.selectMore == 2) {
            all = {
              did: '~' + this.inputMore,
              color_code: this.Color,
              edition_code: this.Ver,
              spring_code: this.Spring,
            }
          } else if (this.selectMore == 3) {
            all = {
              mac: '~' + this.inputMore,
              color_code: this.Color,
              edition_code: this.Ver,
              spring_code: this.Spring,
            }
          }
        } else {
          all = {
            color_code: this.Color,
            edition_code: this.Ver,
            spring_code: this.Spring,
          }
        }
        this.Screenall = {}
        for (var i in all) {
          if (all[i]) {
            this.Screenall[i] = all[i]
            continue
          }
        }
        if (this.Color || this.Ver || this.Spring || (this.selectMore && this.inputMore)) {
          this.GetList(GetWarehouslist, {
            page: this.Curpage,
            token: this.token,
            sort: "-id",
            q: JSON.stringify([{"AND": this.Screenall}])
          })
        } else {
          this.GetList(GetWarehouslist, {page: this.Curpage, token: this.token, sort: "-id"})
        }
      },
      Refresh() {
        this.Color = ""
        this.Ver = ""
        this.Spring = ""
        this.selectMore = ""
        this.inputMore = ""
        this.Curpage = 1
        this.GetList(GetWarehouslist, {page: this.Curpage, token: this.token, sort: "-id"})
      },
      handleCurrentChange(val) {
        this.Curpage = val
        this.Quickfind()
      },
      handleCurrentChange2(val) {
        this.Curpage2 = val
        this.GetList2(GetDeliverlist, {page: this.Curpage2, token: this.token, sort: "-id"})
      },
      ShowIn() {
        this.OutVisible = true
        this.GetList2(GetDeliverlist, {page: this.Curpage2, token: this.token, sort: "-id"})
      },
      selsChange(sels) {
        this.sels = sels;
      },
      OpenClear() {
        var that = this
        var arr = this.sels.map(item => item.did)
        // console.log('lbf', arr)
        that.OutList = []
        for (var i in arr) {
          that.OutList[i] = {}
          that.OutList[i].did = arr[i]
          that.OutList[i].remark = ''
        }
        // console.log('lbf-OutList', that.OutList)
        this.ChuVisible = true
      },
      Chuhuo() {
        var that = this
        if (that.Cform.xxdz && that.Cform.getperson && that.Cform.getphone && that.Cform.ssq && that.Cform.liushui && that.Cform.cct && that.Cform.jxs && that.Cform.person && that.Cform.kind) {
          that.UpOutloading = true
          var dids = that.sels.map(item => item.did);
          var remarklist = {}
          for (var i in that.OutList) {
            that.OutList[i]
            remarklist[that.OutList[i].did] = that.OutList[i].remark
          }
          let url = "/warehouseds/deliverstatus?token=" + this.token
          let para = {
            did_list: dids,
            dealer_id: that.Cform.jxs,
//							remark:this.Cform.more,
            type_code: that.Cform.kind,
            serial_number: that.Cform.liushui,
            shipper: that.Cform.person,
            delivery_date: parseInt((that.Cform.cct.getTime() / 1000)),
            receiver: that.Cform.getperson,
            receiver_phone: that.Cform.getphone,
            shipping_prov: that.Cform.ssq[0],
            shipping_city: that.Cform.ssq[1],
            shipping_dist: that.Cform.ssq[2],
            shipping_addr: that.Cform.xxdz,
            remarks: remarklist
          }
          that.axios.put(url, para).then(res => {
            if (res.status == "200") {
              that.$message({
                type: 'success',
                message: '操作成功!'
              });
              that.UpOutloading = false
              that.ChuVisible = false
              that.GetList(GetWarehouslist, {page: that.Curpage, token: that.token, sort: "-id"})
            } else {
              that.$message.error('对不起，操作失败。')
              that.UpOutloading = false
            }
          }).catch(err => {
            that.$message.error(err.response.data.message)
            that.UpOutloading = false
          })
        } else {
          that.$message.error('请填写完整信息')
        }
      },
      checkboxInit(row, index) {
        if (row.receipt_date == '0') {
          return 0;//不可勾选
        } else {
          return 1;//可勾选
        }
      },
      Makesure(index, row) {
        this.listloading = true
        this.Form = Object.assign({}, row);
        let u = "/warehouseds/" + this.Form.id + "/receiptstatus?token=" + this.token
        this.axios.put(u).then(res => {
          if (res.status == "200") {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.GetList(GetWarehouslist, {page: this.Curpage, token: this.token, sort: "-id"})
          } else {
            this.$message.error('对不起，操作失败。')
            this.listloading = false
          }
        }).catch(err => {
          this.$message.error(err.response.data.message)
          this.listloading = false
        })
      },
      dataForm(row, column) {
        var data = row[column.property]
        if (data == undefined) {
          return ""
        }
        data = data.slice(2, 9)
        return data
      },
      chuTimeFormatter(para) {
        if (para == "") {
          return "未填写"
        } else {
          var date = para * 1000
          if (date == undefined) {
            return 'undefined'
          } else if (date == 0) {
            return "0"
          }
          return moment(date).format("YYYY-MM-DD")
        }
      }
    },
    created() {
      this.token = sessionStorage.getItem("BBRtoken");
      this.Limits = JSON.parse(sessionStorage.getItem("limits"))
      this.GetList(GetWarehouslist, {page: this.Curpage, token: this.token, sort: "-id"})
      this.GetDealerList(GetDealerlist)
      this.Addoptions = CountryThree
    },
    mounted() {
      this.$nextTick(function () {
        this.Gethigh()
      })
    }
  }

</script>

<style scoped>
  .el-select {
    width: 100px;
  }
</style>


// WEBPACK FOOTER //
// WarehousingEquipment.vue?8d01ed64